/**
 * -----------------------------------------------------------------------------
 * useOrderPreview
 * -----------------------------------------------------------------------------
 *
 * PURPOSE:
 * Handles zooming behavior for Order Preview layer.
 *
 * RESPONSIBILITIES:
 *   - Auto fitBounds for single order
 *   - Restore zoom when needed
 *
 * DOES NOT:
 *   - Create layers
 *   - Manage sources
 *
 * That is handled by useGeoJsonLayer.
 * -----------------------------------------------------------------------------
 */

import { useEffect, useRef } from "react";
import { calculateBoundingBoxCoordinates } from "../utils/helperFunctions.jsx";

const useOrderPreview = (mapRef, orderPreview) => {
  const prevZoomRef = useRef(null);

  /* -------------------------------------------------------------------------- */
  /*                               Zoom Handling                                */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    const map = mapRef.current;
    if (!map || !orderPreview) return;

    const isMultiple = Array.isArray(orderPreview);

    const bBox = !isMultiple
      ? calculateBoundingBoxCoordinates(orderPreview)
      : null;

    if (!isMultiple) {
      if (orderPreview?.geometry?.type === "Point") {
        if (prevZoomRef.current === null) {
          prevZoomRef.current = map.getZoom();
        }
        map.fitBounds(bBox, {
          padding: 20,
          duration: 1000,
          maxZoom: 15,
        });
      } else if (orderPreview && orderPreview?.geometry?.type !== "Point") {
        const restoreZoom =
          prevZoomRef.current !== null ? prevZoomRef.current : map.getZoom();

          map.easeTo({
          zoom: restoreZoom,
          duration: 800,
        });

        prevZoomRef.current = null;
      }
    }
  }, [orderPreview, mapRef]);

  return null;
};

export default useOrderPreview;
